const SIZES = {
  xs: "h-4 w-4 border-2",
  sm: "h-6 w-6 border-4",
  md: "h-8 w-8 border-4",
  lg: "h-12 w-12 border-4",
};

const VARIANTS = {
  inline: "inline-flex items-center",
  block: "flex w-full items-center justify-center py-12",
  overlay: "absolute inset-0 z-10 flex items-center justify-center bg-surface/70",
};

/**
 * Brand spinner announced to assistive tech as a status region.
 *
 * @param {object} props
 * @param {"xs"|"sm"|"md"|"lg"} [props.size="md"] Ring diameter (16/24/32/48px).
 * @param {string} [props.label="Loading"] Screen-reader text.
 * @param {"inline"|"block"|"overlay"} [props.variant="block"] `inline` sits in text flow with no padding;
 *   `block` centers inside a padded full-width row; `overlay` covers the nearest `relative` parent.
 * @param {string} [props.className] Extra classes for the wrapper.
 */
const Loader = ({ size = "md", label = "Loading", variant = "block", className = "" }) => (
  <div role="status" className={`${VARIANTS[variant] || VARIANTS.block} ${className}`.trim()}>
    <span
      aria-hidden="true"
      className={`inline-block animate-spin rounded-full border-brand-500 border-r-transparent ${
        SIZES[size] || SIZES.md
      }`}
    />
    <span className="sr-only">{label}</span>
  </div>
);

export default Loader;
